<template lang="pug">
  div
    v-btn(color="info" text @click="selectFiles") 上傳照片
    v-dialog(:value="files !== null" persistent)
      v-card
        v-card-title 圖片上傳中...
        v-container.fill-height(v-if="snapshot" fluid)
          v-layout.pa-3(column align-center justify-center)
            v-flex
              v-progress-circular.pa-5(:value="snapshot.filter(item => item.state === 'succeed').length / snapshot.length * 100"
                :rotate="-90")
            v-flex
              p 已上傳 {{ snapshot.filter(item => item.state === 'succeed').length }}張 / 共 {{ snapshot.length }} 張
        v-card-actions
          v-spacer
          v-btn(color="error" text @click="cancel") 取消
          v-spacer
    input(ref="input" :style="{ display: 'none' }" type="file"
       multiple accept="image/*" @change="onFileChange")
    check-dialog(:open="alert.open" :title="alert.title" @check="alert.open = false")
</template>
<script>
import { db, photoStorage } from "@/firebase";
import CheckDialog from "@/components/core/CheckDialog.vue";

class FileUploader {
  constructor(path) {
    this.bucket = photoStorage;
    this.path = path;
    this.observers = new Map();
    this.files = null;
    this.snapshot = null;
    this._cancel = false;
    this._currentTask = null;
  }

  on(event, ob) {
    this.observers.set(event, ob);
  }

  cancel() {
    this._cancel = true;
    if (this._currentTask) {
      this._currentTask.cancel();
    }
  }

  async upload(files, metadata) {
    this.files = files;
    const snapshot = [];
    for (const file of files) {
      snapshot.push({
        name: file.name,
        state: "waiting",
        progress: 0,
        downloadURL: null,
        bucket: this.storageName,
        id: null,
        path: null
      });
    }

    this.snapshot = snapshot;
    for (let i = 0, l = files.length; i < l; i += 1) {
      if (this._cancel) break;
      await this.uploadTask(i, metadata);
    }

    // finish
    if (!this._cancel) {
      this._onFinish();
    }

    // reset
    this.reset();
  }

  async uploadTask(index, metadata) {
    this._onUpdate(index, { state: "uploading" });
    const file = this.files[index];
    const ext = file.name.match(/.\w+$/)[0];
    const fileId = db.collection("_").doc().id;
    const fileName = `${fileId}${ext}`;
    const filePath = this.path + "/" + fileName;
    const ref = this.bucket.ref(filePath);

    this._currentTask = ref.put(file, metadata);

    try {
      const downloadURL = await new Promise((res, rej) => {
        this._currentTask.on(
          "state_changed",
          snapshot => {
            if (this._cancel) {
              this._currentTask.cancel();
            }
            const progress =
              Math.floor(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this._onUpdate(index, { progress });
          },
          err => {
            rej(err);
          },
          async () => {
            const downloadURL = await this._currentTask.snapshot.ref.getDownloadURL();
            // eachSucceed hook
            this._onEachSucceed(index, {
              id: fileId,
              path: filePath,
              bucket: this._currentTask.snapshot.ref.bucket,
              downloadURL
            });
            res(downloadURL);
          }
        );
      });
      this._onUpdate(index, { state: "succeed", downloadURL });
    } catch (e) {
      this._onUpdate(index, { state: "fail" });
    }
  }

  reset() {
    this.files = null;
    this.snapshot = null;
    this._cancel = false;
    this._currentTask = null;
  }

  _onUpdate(index, payload) {
    Object.assign(this.snapshot[index], payload);
    const updateObserver = this.observers.get("update");
    if (updateObserver) {
      updateObserver(this.snapshot);
    }
  }

  _onEachSucceed(index, payload) {
    Object.assign(this.snapshot[index], payload);
    const eachSucceedObserver = this.observers.get("each_succeed");
    if (eachSucceedObserver) {
      eachSucceedObserver(this.snapshot[index]);
    }
  }

  _onFinish() {
    const finishObserver = this.observers.get("finish");
    if (finishObserver) {
      finishObserver();
    }
  }
}

export default {
  name: "NewPhotoEditor",
  components: {
    CheckDialog
  },
  props: {
    articleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      snapshot: null,
      files: null,
      uploader: null,
      alert: {
        open: false,
        title: ""
      }
    };
  },
  methods: {
    selectFiles() {
      //clear files
      this.$refs.input.value = "";
      this.$refs.input.click();
    },
    async onFileChange(e) {
      this.files = e.target.files;
      this.upload();
    },
    async upload() {
      const uploader = new FileUploader(`articles/${this.articleId}`);
      uploader.on("update", snapshot => {
        this.snapshot = snapshot;
      });
      uploader.on("finish", async () => {
        this.alert.open = true;
        this.alert.title = "照片上傳完成";
      });
      this.uploader = uploader;
      await this.uploader.upload(this.files);
      this.cancel();
    },
    async cancel() {
      if (this.uploader) {
        await this.uploader.cancel();
      }
      this.uploader = null;
      this.$refs.input.value = "";
      this.files = null;
      this.snapshot = null;
    }
  }
}
</script>
